import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve relative storage paths (e.g. /api/files/...) to absolute URLs for <img src>
export const resolveImg = (url) => {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

export default api;
